import { Injectable }         from '@angular/core';
import { InvalidEntityEnum }  from '@models/entity.model';
import { InvalidEntitiesDTO } from '@openApiGenerated/management-api';
import { LoggerService }      from '@shared/services/logger.service';

@Injectable( {
	providedIn: 'root'
} )
export class ErrorsMapperService {

	constructor(
		private _logger: LoggerService
	) { }

	get errors() {
		return {
			invalidEntitiesDtoToTmo: this.mapInvalidEntitiesDtoToTmo.bind( this ) as typeof this.mapInvalidEntitiesDtoToTmo,
			invalidEntitiesTmoToDto: this.mapInvalidEntitiesTmoToDto.bind( this ) as typeof this.mapInvalidEntitiesTmoToDto,
			invalidEntityDtoToTmo: this.mapInvalidEntityDtoToTmo.bind( this ) as typeof this.mapInvalidEntityDtoToTmo,
			invalidEntityTmoToDto: this.mapInvalidEntityTmoToDto.bind( this ) as typeof this.mapInvalidEntityTmoToDto
		};
	}

	private mapInvalidEntityDtoToTmo( invalidEntity: InvalidEntitiesDTO ): InvalidEntityEnum {
		switch ( invalidEntity ) {
			case InvalidEntitiesDTO.BUSINESS_PREMISES:
				return InvalidEntityEnum.BUSINESS_PREMISES;

			case InvalidEntitiesDTO.ERS:
				return InvalidEntityEnum.ERS;

			case InvalidEntitiesDTO.ORGANIZATION:
				return InvalidEntityEnum.ORGANIZATION;

			default:
				this._logger.warn( `mapInvalidEntityDtoToTmo has no case for DTO ${ invalidEntity }` );
				return null;
		}
	}

	private mapInvalidEntityTmoToDto( invalidEntity: InvalidEntityEnum ): InvalidEntitiesDTO {
		switch ( invalidEntity ) {
			case InvalidEntityEnum.BUSINESS_PREMISES:
				return InvalidEntitiesDTO.BUSINESS_PREMISES;

			case InvalidEntityEnum.ERS:
				return InvalidEntitiesDTO.ERS;

			case InvalidEntityEnum.ORGANIZATION:
				return InvalidEntitiesDTO.ORGANIZATION;

			default:
				this._logger.warn( `mapInvalidEntityTmoToDto has no case for TMO ${ invalidEntity }` );
				return null;
		}
	}

	private mapInvalidEntitiesDtoToTmo( invalidEntities: InvalidEntitiesDTO[] ): InvalidEntityEnum[] {
		return invalidEntities.map(
			( invalidEntity: InvalidEntitiesDTO ) => this.mapInvalidEntityDtoToTmo( invalidEntity )
		);
	}

	private mapInvalidEntitiesTmoToDto( invalidEntities: InvalidEntityEnum[] ): InvalidEntitiesDTO[] {
		return invalidEntities.map(
			( invalidEntity: InvalidEntityEnum ) => this.mapInvalidEntityTmoToDto( invalidEntity )
		);
	}
}
